<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Tuition Programs</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <add-program-modal @created="handleUpdateTable" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <tuition-program-table
              :data="data"
              :loading="loading"
              @updateTable="handleUpdateTable"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import AddProgramModal from '@/components/tuition/manage/program/Add'
import TuitionProgramTable from '@/components/tuition/manage/program/Table'

export default {
  name: 'TuitionProgramView',
  components: {
    AddProgramModal,
    TuitionProgramTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-program', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loading: false,
      data: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  mounted() {
    this.fetchPrograms()
  },
  methods: {
    fetchPrograms() {
      this.loading = true
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.data = data.data || data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleUpdateTable() {
      this.fetchPrograms()
    },
  },
}
</script>
